export const regName = {
  itemType: "input",
  required: true,
  data: {
    id: "name",
    label: "姓名",
    placeholder: "",
    value: "",
    otherInfo: "",
  },
};

export const regGender = {
  itemType: "radio",
  required: true,
  data: {
    id: "gender",
    label: "性別",
    placeholder: "",
    value: "",
    otherInfo: "",
    options: [
      {
        label: "男",
        value: "male",
      },
      {
        label: "女",
        value: "female",
      },
      {
        label: "其他",
        value: "other",
      },
    ],
  },
};
export const regBirth = {
  itemType: "date",
  required: true,
  data: {
    id: "birth",
    label: "生日",
    placeholder: "",
    value: "",
    otherInfo: "",
  },
};
export const regPhoneNumber = {
  itemType: "input",
  required: true,
  data: {
    id: "phoneNumber",
    label: "主要聯絡電話（🇹🇼+886）",
    placeholder: "",
    value: "",
    otherInfo: "",
  },
};
export const regAddress = {
  itemType: "address",
  required: false,
  data: {
    id: "isAddress",
    label: "",
    placeholder: "",
    value: "",
    otherInfo: "",
  },
};
export const regContactPhone = {
  itemType: "dynamicInputSection",
  required: false,
  data: {
    id: "contactPhone",
    label: "其他聯絡電話",
    placeholder: "請輸入電話",
    value: "",
    otherInfo: "",
    defaultValue: { contactPhone: "" },
  },
};

export const regTaxIdNumber = {
  itemType: "input",
  required: false,
  data: {
    id: "taxIdNumber",
    label: "統一編號",
    placeholder: "",
    value: "",
    otherInfo: "",
  },
};

export const regInvoiceCarrier = {
  itemType: "input",
  required: false,
  data: {
    id: "invoiceCarrier",
    label: "載具條碼",
    placeholder: "以「/」開頭,共 8 碼",
    value: "",
    otherInfo: "",
  },
};
export const regInvoiceType = {
  itemType: "radio",
  required: false,
  data: {
    id: "invoiceType",
    label: "發票類型",
    placeholder: "",
    value: "",
    otherInfo: "",
    options: [
      {
        label: "手機載具",
        value: "I",
      },
      {
        label: "公司統編",
        value: "T",
      },
      {
        label: "其他",
        value: "O",
      },
    ],
  },
};

export const regAgree = {
  itemType: "checkbox",
  required: false,
  data: {
    id: "agree",
    label: "我已同意 LPG Cloud 的",
    placeholder: "",
    value: "",
    otherInfo: "",
    statement: {
      need: true,
      title: "使用者協議",
    },
  },
};
